import React from "react";
import { connect } from "react-redux";

import { OnlineLink, Skeleton } from "components";

import styles from "./general.module.scss";

type FieldWithLoaderProps = {
	label: string;
	value?: string | number | HTMLElement | JSX.Element | any;
	linkTo?: string;
	loading?: boolean;
	timeZoneRequestLoading?: boolean;
	isTimeZoneField?: boolean;
	isInline?: boolean;
	isTwoLine?: boolean;
};
const FieldWithLoader = ({
	label,
	value,
	linkTo,
	loading = false,
	timeZoneRequestLoading = false,
	isTimeZoneField = false,
	isInline,
	isTwoLine,
}: FieldWithLoaderProps) => {
	const isTimeZoneLoading =
		!timeZoneRequestLoading && !loading ? false : true;
	const isLoading = !isTimeZoneField ? loading : isTimeZoneLoading;
	const inlineClassName = isInline && styles.isInline;
	const isTwoLineClassName = isTwoLine && styles.isTwoLine;
	return (
		<div
			className={`${styles.wrappContent} ${inlineClassName} ${isTwoLineClassName}`}
		>
			<p className={styles.title}>{label}</p>

			{isLoading ? (
				<Skeleton variant="text" height="24px" width="100%" />
			) : (
				<p
					className={styles.result}
					data-autotest={(
						label.charAt(0).toLowerCase() + label.slice(1)
					).replace(/\s/g, "")}
				>
					{linkTo ? (
						<OnlineLink to={linkTo}>{value}</OnlineLink>
					) : (
						value
					)}
				</p>
			)}
		</div>
	);
};

const mapStateToProps = state => ({
	loading: state.merchantGeneral.loading.generalData,
	timeZoneRequestLoading: state.dropdownValues.loading.merchantTimeZone,
});

export default connect(mapStateToProps, null)(FieldWithLoader);
